export default __webpack_public_path__ + "static/images/dr-crystal@2x.9352a6a2c03bd3cb4aa4b70ccc50f56f.png";